// extracted by mini-css-extract-plugin
export default {"input":"Tcqmu","select":"zZxK9","status-select":"XI8aI","rate":"VTLc4","titles":"tUG36","description":"bTeZt","title":"sOxPt"};